<template>
  <ion-page>
    <ion-content>
      <cafeItemHeader :cafeInfo="cafeInfo" />
      <div class="cafeinfo-container-sticky">
        <h1 class="h1-cafe">
          {{ cafeInfo.shopName }}
        </h1>
        <img
          class="heart-icon"
          v-if="isFavorite"
          @click="!isProcessing && removeFromFavorites()"
          src="assets/icon/heart-red.svg"
        />
        <img
          class="heart-icon"
          v-if="!isFavorite"
          @click="!isProcessing && markAsFavorite()"
          src="assets/icon/heart.svg"
        />
      </div>

      <div class="cafeinfo-container" id="result" v-if="cafeInfo">
        <div class="cafe-info-line status-row">
          <span v-if="cafeInfo.isOpen" class="status-badge open">Open Now</span>
          <span v-else class="status-badge closed">Closed</span>
        </div>
        <div class="cafe-info-line">
          <ion-icon
            src="assets/icon/distance.svg"
            class="banner-icon"
          ></ion-icon>
          <span
            class="h2-cafe address-link"
            id="destinationSpan"
            @click="openInGoogleMaps"
          >
            {{ cafeInfo.address }}
          </span>
        </div>
        <div class="cafe-info-line">
          <ion-icon
            src="assets/icon/time-outline.svg"
            class="banner-icon"
          ></ion-icon>
          <span class="cafeinfo-txt hours-text">{{ getFormattedHours() }}</span>
        </div>
      </div>
      <ReorderFavorite name="ReorderFavorite" />
      <!--content start -->
      <cafeItemDetailsDrawer
        :product="product"
        :variations="variations"
        :addons="addons"
        :productOriginalPrice="productOriginalPrice"
        :productId="productId"
        :cartOrders="cartOrders"
        :active="active.product_drawer"
        :cafeInfo="cafeInfo"
        v-on:close-product-drawer="closeProductDrawer()"
        v-on:cart-updated="handleCartUpdated()"
      />
      <!--<ion-row class="heading-row"
        ><h1 class="heading-category">Most Popular</h1></ion-row
      >
      <div v-if="Object.keys(mostPopularCafeProducts).length !== 0">
        <cafeItemCard
          v-for="product in mostPopularCafeProducts"
          :key="product.id"
          :product="product"
          v-on:view-product="viewProduct($event)"
        />
      </div>
      <div style="padding: 1em; font-family: 'Gilroy'; font-size: 14px" v-else>
        No product/s available for this cafe.
      </div>-->
      <div class="tab-wrap tabset">
        <!-- Dynamic Category Tabs -->
        <div class="category-tabs-row">
          <button
            v-for="category in availableCategories"
            :key="'tab-' + category"
            type="button"
            class="category-tab-btn"
            :class="{ active: selectedCategory === category }"
            @click="selectedCategory = category"
          >
            {{ category }}
          </button>
        </div>

        <!-- Dynamic Category Products -->
        <div
          v-for="category in availableCategories"
          :key="'content-' + category"
          class="tab-content-dynamic"
          :class="{ 'tab-content-active': selectedCategory === category }"
        >
          <cafeItemCard
            v-for="product in productsByCategory[category]"
            :key="product.cafeProducts.id"
            :product="product"
            v-on:view-product="viewProduct($event)"
          />
        </div>

        <!-- No products message -->
        <div v-if="availableCategories.length === 0" class="no-products-msg">
          No product/s available for this cafe.
        </div>
      </div>
      <!-- <ion-row class="heading-row-list"
        ><h1 class="heading-category">Tea</h1></ion-row
      >
      <cafeItemListCard
        v-for="product in cafeitem"
        :key="product.id"
        :product="product"
        v-on:view-product="viewProduct($event)"
      />

      <ion-row class="heading-row-list"
        ><h1 class="heading-category">Extras</h1></ion-row
      >
      <cafeItemListCard
        v-for="product in cafeitem"
        :key="product.id"
        :product="product"
        v-on:view-product="viewProduct($event)"
      /> -->
    </ion-content>
    <TheFooter name="TheFooter" />
    <!-- content end -->
  </ion-page>
</template>
<script>
import { defineComponent } from "vue";
import {
  IonPage,
  IonContent,
  IonRow,
  IonCol,
  IonButton,
  IonIcon,
} from "@ionic/vue";
import axios from "axios";
import cafeitem from "@/data/cafeitem.js";
import cafeItemCard from "@/components/product/cafeItemCard.vue";
import cafeItemDetailsDrawer from "@/components/product/cafeItemDetailsDrawer.vue";
import cafeItemHeader from "@/components/product/cafeItemHeader.vue";
import TheFooter from "@/components/TheFooter.vue";
import ReorderFavorite from "@/components/ReorderFavorite.vue";
import { Geolocation } from "@capacitor/geolocation";
import { formatBusinessHours } from "@/utils/businessHours";
import { distanceCache } from "@/utils/distanceCache";

const BASE_URI =
  process.env.VUE_APP_BASE_URI !== undefined
    ? process.env.VUE_APP_BASE_URI
    : "https://api.onecoffeeapp.com.au";

export default defineComponent({
  name: "CafeMenu",
  components: {
    IonPage,
    IonContent,
    TheFooter,
    cafeItemCard,
    cafeItemDetailsDrawer,
    cafeItemHeader,
    ReorderFavorite,
    IonRow,
    IonCol,
    IonButton,
    IonIcon,
  },
  data() {
    return {
      cafeitem: cafeitem,
      cafeProducts: {},
      mostPopularCafeProducts: {},
      // Dynamic categories object: { "CategoryName": [products...], ... }
      productsByCategory: {},
      // Ordered list of category names as they appear
      categoryOrder: [],
      cafeInfo: {},
      product: {},
      variations: {},
      addons: {},
      productOriginalPrice: null,
      productId: null,
      cartOrders: [],
      totalCartQty: 0,
      subTotalCartPrice: 0,
      active: {
        product_drawer: false,
      },
      duration: "",
      distance: "",
      isFavorite: false,
      isProcessing: false,
      cafeId: "",
      userId: "",
      selectedCategory: null,
    };
  },
  computed: {
    // Returns array of categories that have products
    availableCategories() {
      return this.categoryOrder.filter(
        (cat) =>
          this.productsByCategory[cat] &&
          this.productsByCategory[cat].length > 0
      );
    },
    firstAvailableCategory() {
      return this.availableCategories[0] || null;
    },
  },
  mounted() {
    setTimeout(() => {
      this.getUserLocation();
    }, 2000); // 2000 milliseconds (2 seconds)
  },
  methods: {
    setFocus: function () {
      window.addEventListener("load", function () {
        document.getElementById("tab1").focus();
      });
    },
    async markAsFavorite() {
      this.isProcessing = true;
      let paramsData = {
        userId: this.userId,
        cafeId: this.cafeId,
      };

      let axiosConfig = {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json;charset=UTF-8",
        },
      };

      await axios
        .post(BASE_URI + "/favorites/create-favorites", paramsData, axiosConfig)
        .finally(() => {
          this.isProcessing = false;
        });

      this.isFavorite = true;
    },
    async removeFromFavorites() {
      this.isProcessing = true;
      let paramsData = {
        userId: this.userId,
        cafeId: this.cafeId,
      };

      let axiosConfig = {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json;charset=UTF-8",
        },
        params: paramsData,
      };

      await axios
        .delete(BASE_URI + "/favorites/delete-favorites", axiosConfig)
        .finally(() => {
          this.isProcessing = false;
        });

      this.isFavorite = false;
    },
    viewProduct(product) {
      this.product = product.cafeProducts;
      this.variations = product.cafeProducts.variations;
      this.addons = product.addons.name;
      this.productOriginalPrice = parseFloat(
        product.cafeProducts.originalPrice
      );
      this.productId = product.cafeProducts.id;

      this.active.product_drawer = true;
    },
    closeProductDrawer() {
      this.active.product_drawer = false;
    },
    async handleCartUpdated() {
      // Force refresh the Vuex store cart orders (updates TheFooter badge)
      await this.$store.dispatch("fetchCartOrders", { force: true });

      // Also refresh local cart orders for this page
      await this.getCartOrders(this.userId, this.cafeId);
    },
    getFormattedHours() {
      if (!this.cafeInfo || !this.cafeInfo.businessHours) {
        return "Hours not available";
      }
      return formatBusinessHours(this.cafeInfo.businessHours);
    },
    openInGoogleMaps() {
      if (!this.cafeInfo.address) return;
      const encodedAddress = encodeURIComponent(this.cafeInfo.address);
      const url = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
      window.open(url, "_blank");
    },
    async getCafeProductsByCafeId(cafeId) {
      let axiosConfig = {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json;charset=UTF-8",
        },
      };

      let result = await axios.get(
        BASE_URI + "/product/get-cafe-products/" + cafeId,
        axiosConfig
      );

      const categoryMap = {};
      const categoryOrderSet = new Set();
      let popularCount = 0;

      for (let i = 0; i < result.data.data.length; i++) {
        const productData = result.data.data[i];
        const category = productData.category || "Other";

        const productWrapper = {
          cafeProducts: productData,
          addons: {
            name: ["Milk", "Size", "Sugar", "Strength", "Flavour"],
          },
        };

        // Add to cafeProducts
        this.cafeProducts[i] = productWrapper;

        // Track popular products
        if (productData.is_popular == 1 && popularCount < 6) {
          this.mostPopularCafeProducts[popularCount] = productWrapper;
          popularCount++;
        }

        // Group by category dynamically
        if (!categoryMap[category]) {
          categoryMap[category] = [];
          categoryOrderSet.add(category);
        }
        categoryMap[category].push(productWrapper);
      }

      // Update reactive data
      this.productsByCategory = categoryMap;
      this.categoryOrder = Array.from(categoryOrderSet);
    },
    async getCoffeeShopsById(cafeId) {
      let axiosConfig = {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json;charset=UTF-8",
        },
      };

      let result = await axios.get(
        BASE_URI + "/cafe/get-coffee-shops/" + cafeId,
        axiosConfig
      );

      this.cafeInfo =
        result && result.data.data.length ? await result.data.data[0] : {};
    },
    async getCartOrders(userId, cafeId) {
      // Don't fetch cart orders if user is not logged in
      const token = localStorage.getItem("token");
      const isValidUserId =
        userId && userId !== "null" && userId !== "undefined" && userId !== "";
      const isValidToken =
        token && token !== "null" && token !== "undefined" && token !== "";

      if (!isValidUserId || !isValidToken) {
        this.cartOrders = [];
        this.totalCartQty = 0;
        this.subTotalCartPrice = 0;
        return;
      }

      let axiosConfig = {
        headers: {
          Authorization: token,
          "Content-Type": "application/json;charset=UTF-8",
        },
      };

      let url =
        BASE_URI +
        "/cart/get-cart-orders/?userId=" +
        userId +
        "&cafeId=" +
        cafeId +
        "&status=pending";

      let result = await axios
        .get(url, axiosConfig)
        .then((res) => res.data)
        .catch((err) => {
          throw err.response.status;
        });

      this.cartOrders = result && result.data.length ? await result.data : [];

      for (let i = 0; i < this.cartOrders.length; i++) {
        this.totalCartQty += this.cartOrders[i].quantity;
        this.subTotalCartPrice += this.cartOrders[i].pricePerOrder;
      }
    },
    async getUserLocation() {
      try {
        // Check and request permission
        const permStatus = await Geolocation.checkPermissions();
        if (permStatus.location !== "granted") {
          const requestResult = await Geolocation.requestPermissions();
          if (requestResult.location !== "granted") {
            console.warn("Location permission denied");
            return;
          }
        }

        // Get current position
        const position = await Geolocation.getCurrentPosition({
          enableHighAccuracy: false,
          timeout: 15000,
          maximumAge: 300000,
        });

        // eslint-disable-next-line no-undef
        const userLocation = new google.maps.LatLng(
          position.coords.latitude,
          position.coords.longitude
        );

        // Check cache first
        const cached = distanceCache.get(this.cafeId, userLocation);
        if (cached) {
          this.distance = cached.distance;
          this.duration = cached.duration;
          return;
        }

        // Cache miss - calculate via API
        const destinationElement = document.getElementById("destinationSpan");
        const destination = destinationElement.textContent;
        this.initMap(userLocation, destination);
      } catch (error) {
        console.error("Error getting user's location:", error.message || error);
      }
    },
    initMap(userLocation, destination) {
      // eslint-disable-next-line no-undef
      const service = new google.maps.DistanceMatrixService();
      service.getDistanceMatrix(
        {
          origins: [userLocation],
          destinations: [destination],
          travelMode: "DRIVING", // You can change this mode
          // eslint-disable-next-line no-undef
          unitSystem: google.maps.UnitSystem.METRIC,
          avoidHighways: false,
          avoidTolls: false,
        },
        (response, status) => {
          if (status === "OK") {
            this.duration = response.rows[0].elements[0].duration.text;
            this.distance = response.rows[0].elements[0].distance.text;
            // Store in cache
            distanceCache.set(
              this.cafeId,
              userLocation,
              this.distance,
              this.duration
            );
          } else {
            document.getElementById("result").textContent =
              "Error in the response";
          }
        }
      );
    },
  },
  async created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const cafeId = urlParams.get("id") || "";
    const userId = localStorage.getItem("id") || null;
    localStorage.setItem("cafeId", cafeId);
    this.cafeId = urlParams.get("id") || "";
    this.userId = localStorage.getItem("id") || null;

    await this.getCafeProductsByCafeId(cafeId);
    await this.getCoffeeShopsById(cafeId);
    await this.getCartOrders(userId, cafeId);

    // Set initial selected category to first available
    this.selectedCategory = this.firstAvailableCategory;

    // check if the coffee shop is already marked as a favorite (only if logged in)
    const token = localStorage.getItem("token");
    const isValidUserId =
      userId && userId !== "null" && userId !== "undefined" && userId !== "";
    const isValidToken =
      token && token !== "null" && token !== "undefined" && token !== "";
    this.isFavorite = false;

    if (isValidUserId && isValidToken) {
      let paramsData = {
        userId: this.userId,
        cafeId: this.cafeId,
      };

      let axiosConfig = {
        headers: {
          Authorization: token,
          "Content-Type": "application/json;charset=UTF-8",
        },
        params: paramsData,
      };

      await axios
        .get(BASE_URI + "/favorites/get-favorites", axiosConfig)
        .then((response) => {
          if (parseInt(response.data.total_count) > 0) {
            this.isFavorite = true;
          }
        })
        .catch((error) => {
          throw error;
        });
    }
  },
});
</script>
<style scoped>
.heading-row {
  background-color: #f9f9f9;
  margin-top: 20px;
  padding-left: 15px;
}
.heading-row-list {
  background-color: #f9f9f9;
  margin-top: 0px;
  padding-left: 15px;
  border-bottom: 1px solid #f3f3f3;
  width: 100%;
}
.heading-category {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: right;
  color: #1b1b1b;
  margin-bottom: 5px;
  margin-top: 5px;
}
ion-button {
  --background: #ffffff;
  --background-hover: #dce8ff;
  --background-activated: #dce8ff;
  --background-focused: #dce8ff;
  --color: #1b1b1b;
  --border-radius: 4px;
  --border-color: #f3f3f3;
  --border-style: solid;
  --border-width: 1px;
  --ripple-color: #dce8ff;
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 0px;
  margin-bottom: 130px;
  height: 52px;
  text-transform: none;
  --box-shadow: none;
}
ion-button:active {
  --color: #0057ff;
}
.carttext-btn {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
}
.cartprice-btn {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  position: absolute;
  right: 16px;
}
.cartquantity-btn {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 8px;
  position: absolute;
  left: 16px;
  background-color: #ff5500;
  padding: 10px;
  border-radius: 4px;
}
.cafeinfo-container-sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background: #ffffff;
  z-index: 101;
  padding: 5px 20px 5px 20px;
}
.cafeinfo-container {
  padding: 0px 20px 20px 20px;
  border-bottom: 1px solid #f3f3f3;
}
.h1-cafe {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  color: #1b1b1b;
  margin-top: 10px;
  margin-bottom: 5px;
}
.h2-cafe {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  color: #f87e63;
  margin-top: 0px;
  margin-bottom: 5px;
  text-align: left;
  display: inline;
}
.address-link {
  cursor: pointer;
}
.address-link:hover {
  opacity: 0.8;
}
.address-link:active {
  opacity: 0.6;
}
.banner-icon {
  vertical-align: middle;
  padding-right: 5px;
  width: 11px;
}
.dotsep-icon {
  vertical-align: middle;
  width: 3px;
  height: 3px;
  padding-right: 10px;
  padding-left: 10px;
}
.cafeinfo-txt {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 135%;
  letter-spacing: 0.02em;
  color: #1b1b1b;
}
.heart-icon {
  position: relative;
  top: -38px;
  float: right;
}
.status-badge {
  display: inline-block;
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
  margin-left: 5px;
  vertical-align: middle;
}
.status-badge.open {
  background-color: #d4edda;
  color: #155724;
}
.status-badge.closed {
  background-color: #f8d7da;
  color: #721c24;
}
.info-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.info-row:last-child {
  margin-bottom: 0;
}
.status-row {
  margin-bottom: 8px;
}
.hours-row {
  display: flex;
  align-items: center;
  gap: 6px;
}
.hours-text {
  color: #666;
  font-size: 13px;
}

/*
 Tab new start
*/
.tab-wrap {
  -webkit-transition: 0.3s box-shadow ease;
  transition: 0.3s box-shadow ease;
  border-radius: 6px;
  max-width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  position: relative;
  list-style: none;
  background-color: #fff;
  margin-bottom: 4em;
}
.tab {
  display: none;
}
.tab:checked:nth-of-type(1) ~ .tab-content:nth-of-type(1) {
  opacity: 1;
  -webkit-transition: 0.5s opacity ease-in, 0.8s -webkit-transform ease;
  transition: 0.5s opacity ease-in, 0.8s transform ease;
  position: relative;
  top: 0;
  z-index: 100;
  -webkit-transform: translateY(0px);
  -ms-transform: translateY(0px);
  transform: translateY(0px);
  text-shadow: 0 0 0;
}
.tab:checked:nth-of-type(2) ~ .tab-content:nth-of-type(2) {
  opacity: 1;
  -webkit-transition: 0.5s opacity ease-in, 0.8s -webkit-transform ease;
  transition: 0.5s opacity ease-in, 0.8s transform ease;
  position: relative;
  top: 0;
  z-index: 100;
  -webkit-transform: translateY(0px);
  -ms-transform: translateY(0px);
  transform: translateY(0px);
  text-shadow: 0 0 0;
}
.tab:checked:nth-of-type(3) ~ .tab-content:nth-of-type(3) {
  opacity: 1;
  -webkit-transition: 0.5s opacity ease-in, 0.8s -webkit-transform ease;
  transition: 0.5s opacity ease-in, 0.8s transform ease;
  position: relative;
  top: 0;
  z-index: 100;
  -webkit-transform: translateY(0px);
  -ms-transform: translateY(0px);
  transform: translateY(0px);
  text-shadow: 0 0 0;
}
.tab:checked:nth-of-type(4) ~ .tab-content:nth-of-type(4) {
  opacity: 1;
  -webkit-transition: 0.5s opacity ease-in, 0.8s -webkit-transform ease;
  transition: 0.5s opacity ease-in, 0.8s transform ease;
  position: relative;
  top: 0;
  z-index: 100;
  -webkit-transform: translateY(0px);
  -ms-transform: translateY(0px);
  transform: translateY(0px);
  text-shadow: 0 0 0;
}
.tab:checked:nth-of-type(5) ~ .tab-content:nth-of-type(5) {
  opacity: 1;
  -webkit-transition: 0.5s opacity ease-in, 0.8s -webkit-transform ease;
  transition: 0.5s opacity ease-in, 0.8s transform ease;
  position: relative;
  top: 0;
  z-index: 100;
  -webkit-transform: translateY(0px);
  -ms-transform: translateY(0px);
  transform: translateY(0px);
  text-shadow: 0 0 0;
}
.tab:checked + label {
  box-shadow: 0 -1px 0 #fff inset;
  cursor: default;
  color: #ffffff;
  background: #f87e63;
}
.tab:checked + label:hover {
  box-shadow: 0 -1px 0 #fff inset;
  color: #ffffff;
  background: #f87e63;
}
.tab + label {
  box-shadow: 0 -1px 0 #eee inset;
  border-radius: 8px;
  cursor: pointer;
  display: block;
  text-decoration: none;
  display: inline-block;
  padding: 10px 5px 10px 5px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  color: #1b1b1b;
  margin: 10px 5px 10px 5px;
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  -webkit-box-flex: 3;
  -webkit-flex-grow: 3;
  -ms-flex-positive: 3;
  flex-grow: 3;
  text-align: center;
  background-color: #f2f2f2;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-align: center;
  -webkit-transition: 0.3s background-color ease, 0.3s box-shadow ease;
  transition: 0.3s background-color ease, 0.3s box-shadow ease;
  height: 40px;
  box-sizing: border-box;
}
.tab + label:hover {
  color: #ffffff;
  background: #f87e63;
}
.tab-content {
  background-color: transparent;
  position: absolute;
  width: 100%;
  z-index: -1;
  opacity: 0;
  left: 0;
  -webkit-transform: translateY(-3px);
  -ms-transform: translateY(-3px);
  transform: translateY(-3px);
  border-radius: 6px;
}
.cafe-info-line {
  display: flex;
  align-items: flex-start;
  margin-bottom: 5px;
  flex-wrap: nowrap;
}
.cafe-info-line .cafeinfo-txt {
  flex: 1;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.no-products-msg {
  padding: 1em;
  font-family: "Gilroy";
  font-size: 14px;
  width: 100%;
}
/* Dynamic category tabs styling */
.category-tabs-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 5px;
  width: 100%;
}
.category-tab-btn {
  box-shadow: 0 -1px 0 #eee inset;
  border-radius: 8px;
  cursor: pointer;
  display: inline-block;
  padding: 10px 5px;
  font-weight: 600;
  color: #1b1b1b;
  font-family: "Gilroy";
  font-style: normal;
  font-size: 14px;
  flex-grow: 1;
  text-align: center;
  background-color: #f2f2f2;
  border: none;
  user-select: none;
  transition: 0.3s background-color ease, 0.3s box-shadow ease;
  height: 40px;
  box-sizing: border-box;
}
.category-tab-btn:hover {
  color: #ffffff;
  background: #f87e63;
}
.category-tab-btn.active {
  box-shadow: 0 -1px 0 #fff inset;
  cursor: default;
  color: #ffffff;
  background: #f87e63;
}
.tab-content-dynamic {
  display: none;
  width: 100%;
}
.tab-content-dynamic.tab-content-active {
  display: flex;
  flex-wrap: wrap;
}
.tab-content-dynamic::after {
  content: "";
  display: table;
  clear: both;
}
</style>
